import { Record } from "immutable";
import moment from "moment";

const defaults = {
    id: undefined,
    name: undefined,
    description: undefined,
    brandId: undefined,
    applyBeforeSplit: undefined,
    startDate: undefined,
    endDate: undefined,
    rangeUnit: undefined,
    rangeStart: undefined,
    rangeEnd: undefined,
    serviceCode: undefined,
    replacementServiceCode: undefined,
    promotionType: "price",
    price: undefined,
    percentage: undefined,
    hideFromBuyers: undefined,
    active: undefined,
    archived: undefined,
    createdOn: undefined,
    modifiedOn: undefined,
    carrierId: undefined,
    carrierExternalId: undefined,
    fieldName: undefined,
    fieldValue: undefined,
    currency: undefined,
};

export class ShippingPromotion extends Record(defaults) {
    declare id: string;
    declare name: string;
    declare description: string;
    declare brandId: string;
    declare applyBeforeSplit: boolean; // ? not sure
    declare startDate: moment.Moment;
    declare endDate: moment.Moment;
    declare rangeUnit: string;
    declare rangeStart: moment.Moment;
    declare rangeEnd: moment.Moment;
    declare fieldName: string;
    declare fieldValue: string;
    declare serviceCode: string;
    declare replacementServiceCode: string;
    declare promotionType: string;
    declare price: number;
    declare percentage: number;
    declare hideFromBuyers: boolean;
    declare active: boolean;
    declare archived: boolean;
    declare createdOn: moment.Moment;
    declare modifiedOn: moment.Moment;
    declare carrierId: string;
    declare carrierExternalId: string;
    declare currency?: string;

    constructor(args) {
        super({
            ...args,
            brandId: args.brand_id,
            applyBeforeSplit: args.apply_before_split,
            startDate: args.start_date ? moment.utc(parseInt(args.start_date, 10)) : undefined,
            endDate: args.end_date ? moment.utc(parseInt(args.end_date, 10)) : undefined,
            rangeUnit: args.range_unit,
            rangeStart:
                args.range_unit === "amount" && args.range_start ? args.range_start.toFixed(2) : args.range_start,
            rangeEnd: args.range_unit === "amount" && args.range_end ? args.range_end.toFixed(2) : args.range_end,
            price: typeof args.price === "number" ? args.price.toFixed(2) : args.price,
            percentage: typeof args.percentage === "number" ? args.percentage.toFixed(2) : args.percentage,
            serviceCode: args.service_code,
            replacementServiceCode: args.replacement_service_code,
            promotionType: args.promotion_type,
            hideFromBuyers: args.hide_from_buyers,
            carrierId: args.carrier_id, // convience for the frontend UI, not actually in DB
            carrierExternalId: args.external_id, // convience for the frontend UI, not actually in DB
            createdOn: args.created_on ? moment.utc(parseInt(args.created_on, 10)) : undefined,
            modifiedOn: args.modified_on ? moment.utc(parseInt(args.modified_on, 10)) : undefined,
            fieldName: args.field_name,
            fieldValue: args.field_value,
        });
    }

    get _display_modified_on() {
        return moment(this.modifiedOn).local().format("MMM D, YYYY @ h:mm A");
    }
}
